import { z } from 'zod';

export const BoothPatternSchema = z.object({
    pattern: z.string(),
    hallName: z.string().nullable().optional(),
    hallId: z.string(),
    id: z.string().nullable().optional(),
});

export const EventSchema = z.object({
    id: z.string().default(''),
    name: z.string(),
    isActive: z.boolean().default(false),
    slug: z.string(),
    start: z.string(),
    start_tz: z.string().default('America/New_York'), // Intl.supportedValuesOf('timeZone')
    end: z.string(),
    end_tz: z.string().default('America/New_York'), // Intl.supportedValuesOf('timeZone')
    location: z.string().nullable().optional(),
    description: z.string().nullable().optional(),
    website: z.string().nullable().optional(),
    background: z.string().default(''),
    backgroundImage: z.string().default(''),
    color: z.string().default(''),
    hideTeaserText: z.boolean().default(false),
    companies: z
        .object({
            company: z.string(),
            booth: z.string().optional().default(''),
        })
        .array(),
    mapYourShowUrl: z.string().optional().default(''),
    boothPatterns: z.array(BoothPatternSchema).optional().default([]),
});
